export default "__VITE_ASSET__DBGsIYnA__"